import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import DailyQuota from './dailyQuota';
import PriorizationDates from './priorizationDates';


export const vehiclesPriorizationRoutes = [
  {
    'component': <DailyQuota />,
    'path': paths.VehiclesPriorizationDailyQuota,
  },
  {
    'component': <PriorizationDates />,
    'path': paths.VehiclesPriorizationDates,
  },
];
